





import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { stopBodyScroll, allowRefreshOrShare } from '@utils/index'
import { ImagePreview } from 'vant'

@Component({
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
})
export default class SwipePreview extends Vue {
  @Prop({ default: false }) readonly show!: boolean
  @Prop({ default: 0 }) readonly initial!: number
  @Prop({ default: () => [] }) readonly items!: any[]

  isShow = false

  get images() {
    return this.items && this.items.map((item) => item.imgUrl)
  }

  close() {
    this.$emit('hide')
  }

  @Watch('show')
  onChangeShow(val: boolean) {
    this.isShow = val
  }
}
